<template>
  <b-col cols="12" sm="12">
    <b-card class="mx-auto" tile>
      <p v-if="errorNoAdmin" class="text-center text-danger">
        Para registrar Usuarios finales en el grupo: <strong>{{ getNombreArea() }}</strong> primero debe asignarle un usuario
        Administrador a dicho grupo
      </p>
      <span>*{{ $t('Gral.camposObligatorios') }}</span>

      <b-form @submit.stop.prevent="registerUser">
        <b-col cols="12" sm="12">
          <div class="row">
            <b-col cols="12" sm="6">
              <label for="matricula">{{ $t("Gral.usuario") }}: *</label>
              <b-form-input id="matricula" v-model="usuario.matricula" required autocomplete="off"
                :placeholder="$t('vUsuarios.lblAddUser')">
              </b-form-input>
              <b-form-invalid-feedback id="matricula-invalid">
                {{ $t('vUsuarios.lblAddUser') }}
              </b-form-invalid-feedback>
            </b-col>

            <b-col v-if="master" cols="12" sm="6">
              <label for="rol">{{ $t("tableHeaders.rol") }}: *</label>
              <b-form-select id="rol" v-model="selected" :options="roles" value-field="id" text-field="role" required
                @input="inputSelect">
                <template #first>
                  <b-form-select-option :value="null" disabled>
                    {{ $t('vUsuarios.lblSelecRol') }}
                  </b-form-select-option>
                </template>
              </b-form-select>
            </b-col>
          </div>

          <div class="row">
            <b-col cols="12" sm="6">
              <label for="password">{{ $t("vDispositivos.msgPass") }}: *</label>
              <b-form-input id="password" type="password" v-model="usuario.contrasena" required name="password"
                :placeholder="$t('vUsuarios.lblAddPass')" :state="passwordState" pattern=".{6,}"
                :description="$t('vUsuarios.msgIntroPass')" title="La contraseña debe tener al menos 12 caracteres"
                @blur="passwordHasBlurred = true" autocomplete="off">
              </b-form-input>
              <b-form-invalid-feedback id="password-invalid">
                {{ $t('vUsuarios.lblAddPass') }}
              </b-form-invalid-feedback>
              <b-form-invalid-feedback :state="passwordState">
                {{ $t("vUsuarios.msgErroPass") }}
              </b-form-invalid-feedback>
            </b-col>

            <b-col cols="12" sm="6">
              <label for="confirmPassword">{{ $t("vUsuarios.confirPass") }}: *</label>
              <b-form-input id="confirmPassword" v-model="usuario.confirmar" type="password" required
                :placeholder="$t('vUsuarios.lblConfirPass')" :state="confirmPasswordState" pattern=".{6,}"
                @blur="passwordHasBlurred = true" autocomplete="off">
              </b-form-input>
              <b-form-invalid-feedback :state="confirmPasswordState">
                {{ $t("vUsuarios.msgConfirPass") }}
              </b-form-invalid-feedback>
            </b-col>
          </div>

          <!--Seleccionar GRUPO y USUARIO Administrador-->
          <div v-if="master && selected != idMaster" class="row">
            <b-col cols="12" sm="6">
              <label for="nombre">{{ $t("vDispositivos.msgGrupo") }}: *</label>

              <multiselect id="area" v-model="selectedArea" :options="areas" :multiple="isAdmin"
                :placeholder="$t('Gral.escribaBuscar')" track-by="id" label="nombre" @input="onAreaInput"
                :class="areaClass">
              </multiselect>

              <!-- Mensaje de error -->
              <div v-if="areaInvalida" class="invalid-feedback d-block">
                {{ 'Campo requerido' }}
              </div>
            </b-col>
          </div>

          <div v-if="!esUsuarioMaster()" class="row">
            <b-col cols="12" sm="6">
              <label for="nombre">{{ $t("vDispositivos.msgGrupo") }}: *</label>

              <multiselect id="area2" v-model="selectedArea" :options="areasAdministrador" :multiple="false"
                :placeholder="$t('Gral.escribaBuscar')" track-by="id" label="nombre" @input="onAreaInput" required
                :class="areaClass">
              </multiselect>

              <!-- Mensaje de error -->
              <div v-if="areaInvalida" class="invalid-feedback d-block">
                {{ 'Campo requerido' }}
              </div>
            </b-col>
          </div>
          <!--FIN Seleccionar GRUPO y USUARIO Administrador-->

          <b-row>
            <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 d-lg-flex justify-content-lg-end">
              <b-btn variant="info" class="mt-2 ancho-boton w-100" style="color: white" :pressed.sync="btn"
                type="submit" :disabled="!(passwordState && confirmPasswordState)">
                {{ $t("Gral.guardarCont") }}
              </b-btn>
            </div>

            <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 d-lg-flex justify-content-lg-center margin-top-div">
              <b-btn color="primary" class="mt-2 text-light ancho-boton w-100" to="/Usuarios">
                {{ $t("Gral.cancelar") }}
              </b-btn>
            </div>

            <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 d-lg-flex margin-top-div">
              <b-btn variant="info" class="mt-2 ancho-boton w-100" style="color: white" type="submit"
                :disabled="!(passwordState && confirmPasswordState)">
                {{ $t("vUsuarios.saveUser") }}
              </b-btn>
            </div>
          </b-row>
        </b-col>
      </b-form>
    </b-card>
  </b-col>
</template>

<script src="js/main.js"></script>
<script>
import UsersDataService from "../../../services/UsersDataService";
import AreaDataService from "../../../services/AreaDataService";
import AccionesDataService from "../../../services/AccionesDataService";
import Crypto from '../../../services/Crypto';
import { verificarAcceso } from '../../../utils/Session';
import { generalSweetAlert } from '../../../utils/Utils'
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

export default {
  name: "add-Usuario",
  components: { Multiselect },
  data() {
    return {
      usuario: {
        id: 0,
        nombre: "",
        apellido: "",
        matricula: "",
        contrasena: "",
        confirmar: "",
        rol: "",
        area: "",
      },
      btn: false,
      roles: this.obtenerTodosRoles(),
      areas: [],
      master: false,
      passwordHasBlurred: false,
      selected: null,
      // selectedArea puede ser objeto (single) o array (multiple)
      selectedArea: null,
      selectedAdmin: null,
      submitted: false,
      password: "",
      confirmPassword: "",
      idMaster: process.env.VUE_APP_ID_MASTER,
      idFinal: process.env.VUE_APP_ID_USUARIO_FINAL,
      accion: "",
      usuarioLogueado: JSON.parse(sessionStorage.getItem("usuarioLogueado")),
      key: "",
      errorNoAdmin: false,
      usuariosAdmin: [],
      // Validación del campo área
      areaInvalida: false,

      //Rol del usuario logueado
      tipoRol: sessionStorage.getItem("rol"),
      areasAdministrador: [],
    };
  },
  beforeCreate() {
    verificarAcceso();
    if (
      !sessionStorage.getItem("rol") ||
      sessionStorage.idRol === process.env.VUE_APP_ID_USUARIO_FINAL
    ) {
      this.$router.push({
        path: "/monitoreo",
      });
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 4000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: "error",
        title: this.$t("vDispositivos.noPermisos"),
      });
    }
  },
  computed: {
    passwordState() {
      return this.passwordHasBlurred
        ? (this.usuario.contrasena.match(
            "(?:[A-Za-z0-9\\\\\\|\\.\\?\\*\\+\\(\\)\\{\\}\\$\\-\\[\\]\\^,_!@\"#%&/='¿¡ñ<>]+ ){2}[A-Za-z0-9\\\\\\|\\.\\?\\*\\+\\(\\)\\{\\}\\$\\-\\[\\]\\^,_!@\"#%&/='¿¡ñ<>]+"
          )
            ? true
            : false) && this.usuario.contrasena.length >= 12
        : null;
    },
    confirmPasswordState() {
      return this.passwordHasBlurred
        ? this.usuario.contrasena == this.usuario.confirmar &&
          this.usuario.confirmar != ""
          ? true
          : false
        : null;
    },
    passwordState2() {
      return this.passwordHasBlurred
        ? this.usuario.contrasena.length >= 6
          ? true
          : false
        : null;
    },
    confirmPasswordState2() {
      return this.passwordHasBlurred
        ? this.usuario.contrasena == this.usuario.confirmar &&
          this.usuario.confirmar != ""
          ? true
          : false
        : null;
    },

    isAdmin(){
      return this.selected === "6081c4becaae9b0d5e87e61b" || sessionStorage.idRol === process.env.VUE_APP_ID_ADMINISTRADOR;
    },

    areaClass() {
      return { 'is-invalid': this.areaInvalida };
    },
  },

  mounted() {
    this.key = sessionStorage.getItem('key')
    this.obtenerAreas()
    this.obtenerAreasPorUserAdministrativo();

    // normalizar selectedArea según si es admin
    this.$nextTick(() => {
      if (this.isAdmin) {
        if (this.selectedArea == null || !Array.isArray(this.selectedArea)) {
          this.selectedArea = [];
        }
      } else {
        if (Array.isArray(this.selectedArea)) {
          this.selectedArea = this.selectedArea.length ? this.selectedArea[0] : null;
        }
      }
    });
  },

  watch: {
    isAdmin(newVal) {

      if (newVal) {
        // pasar a multiple -> asegurar array
        if (this.selectedArea == null) this.selectedArea = [];
        else if (!Array.isArray(this.selectedArea)) this.selectedArea = [this.selectedArea];
      } else {
        // pasar a single -> tomar el primero o null
        if (Array.isArray(this.selectedArea)) this.selectedArea = this.selectedArea.length ? this.selectedArea[0] : null;
      }
    }
  },

  methods: {

    validateArea() {
      
      if (this.isAdmin) {
        //this.areaInvalida = false;
        
        // Verifica si selectedArea es un array Y si su longitud es mayor a cero.
        const areasSeleccionadas = this.selectedArea;
        const estaVacio = areasSeleccionadas.length === 0;
        
        // Establece la variable de estado para mostrar el error en el template
        this.areaInvalida = estaVacio;

      } else {
        
        this.areaInvalida = !(this.selectedArea && (typeof this.selectedArea === 'object' ? this.selectedArea.id : this.selectedArea));
      }
      return !this.areaInvalida;
    },

    // Normaliza selectedArea (obj | [obj]) y luego valida y emite
    onAreaInput(val) {
      // val puede ser objeto único o array de objetos dependiendo de :multiple
      this.selectedArea = val;
      // emitir normalizado: si quieres ids en el padre/backend cambia aquí
      // ejemplo: emit ids array si multiple, id si single
      if (this.isAdmin) {
        const ids = Array.isArray(this.selectedArea) ? this.selectedArea.map(a => a.id) : [];
        this.$emit('input', ids);
        // cargar admins para la primera area (si aplica)
        if (ids.length) this.usuariosByRolAndArea(ids[0]);
      } else {
        const id = this.selectedArea ? this.selectedArea.id : null;
        this.$emit('input', id);
        if (id) this.usuariosByRolAndArea(id);
      }
      // validar cada vez que cambia
      this.validateArea();
    },

    getDisplayUsuario(usuario) {
      return {
        id: usuario.id,
        matricula: usuario.matricula,
        nombre: usuario.nombre,
        apellido: usuario.apellido,
        contrasena: usuario.contrasena,
        rol: usuario.rol == null ? "NULL" : usuario.rol.role,
        role: usuario.rol,
        habilitado: usuario.habilitado,
        area: usuario.area,
      };
    },

    async registerUser() {
      // validar área requerida
      if (!this.validateArea()) {
        
        // scrolleamos un poco hacia el campo para mejorar UX
        this.$nextTick(() => {
          const el = document.getElementById('area');
          if (el && el.scrollIntoView) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
        return;
      }

      let administrador = "";

      if (sessionStorage.idRol === process.env.VUE_APP_ID_ADMINISTRADOR) {
        //this.selectedArea = sessionStorage.areaUser;
        administrador = sessionStorage.getItem('id_user')
      }
      if (!this.master) {
        this.selected = process.env.VUE_APP_ID_USUARIO_FINAL;
      }

      if (sessionStorage.idRol === process.env.VUE_APP_ID_MASTER && this.selected === process.env.VUE_APP_ID_USUARIO_FINAL) {
        //administrador = this.selectedAdmin

        const adminEncontrado = this.usuariosAdmin
        .find(item => item.id === this.usuario.administrador);

        administrador = adminEncontrado ? adminEncontrado.id : null;
      }

      // Preparar payload area: si isAdmin -> array de objetos, si no -> un objeto


      let areaPayload = null;
      let areaIds = [];

      if (this.isAdmin) {
        
        // Si es admin
        if (Array.isArray(this.selectedArea) && this.selectedArea.length > 0) {
          
          // Primer área como objeto
          areaPayload = this.areas.find(item => item.id === this.selectedArea[0].id) || null;
          // Todos los ids seleccionados
          areaIds = this.selectedArea.map(a => a.id);
        }else{
          areaPayload = this.areas.find(item => item.id === this.selectedArea.id) || null;

          areaIds = [];


        }
      } else {
        // Si no es admin
        areaPayload = this.selectedArea
          ? this.areas.find(item => item.id === this.selectedArea.id)
          : null;
        areaIds = []; // vacío
      }

      const data = {
        matricula: this.usuario.matricula,
        contrasena: this.usuario.contrasena,
        confirmar: this.usuario.confirmar,
        rol: this.roles.find(item => item.id === this.selected),
        area: areaPayload,
        areaIds: areaIds,
        administrador: administrador ?? null,
      };

      
      
      try {
        await UsersDataService.create(data, this.key);
        this.errorNoAdmin = false;

        this.accion = "Ha creado al usuario " + data.matricula;
        this.registrarAccion();

        generalSweetAlert(this.$t('vUsuarios.userReg'), 'success');

        if (this.btn) {
          this.usuario.matricula = "";
          document.getElementById("rol").value = null;
          this.usuario.contrasena = "";
          this.usuario.confirmar = "";
          this.btn = false;
        } else {
          this.$router.push("/usuarios");
        }
      } catch (e) {
        
        if (e.response && e.response.status === 403) {
          this.errorNoAdmin = true
          this.getNombreArea()
          return
        }

        var titulo;
        var decoded = await Crypto.desencriptar(e.response.data, this.key);
        if (e.response.status === 400 && decoded === 1) {
          titulo = this.$t("vUsuarios.userErr1");
        } else {
          titulo = this.$t("vUsuarios.msgErrRegUser");
        }

        generalSweetAlert(titulo, 'error');
      }
    },

    getNombreArea(){
      // devolver nombre(s) dependiendo si es array o single
      if (Array.isArray(this.selectedArea)) {
        return this.selectedArea.map(a => a.nombre).join(', ');
      } else if (this.selectedArea && this.selectedArea.nombre) {
        return this.selectedArea.nombre;
      }
      return '';
    },

    obtenerTodosRoles() {
      UsersDataService.getRoles().then(async(response) => {
        this.roles = await Crypto.desencriptar(response.data, this.key);
      });
    },
    obtenerAreas() {
      AreaDataService.getHabilitados().then(async(response) => {
        this.areas = await Crypto.desencriptar(response.data, this.key);
        this.master = this.esUsuarioMaster()
      });
    },

    /**
     * obtenerAreas
     * Metodo que obtiene las areas asignadas a un usario administrativo
     * @autor DPA
     */
    obtenerAreasPorUserAdministrativo() {
      const usuarioFiltroString = sessionStorage.getItem('usuarioFiltro');

      const estado = (usuarioFiltroString === null || usuarioFiltroString === '' || usuarioFiltroString === 'null')  ? 'VACIO' : 'CON VALOR';
      let id_user;

      if(estado == 'CON VALOR'){
        const isUserFiltrado = JSON.parse(usuarioFiltroString);
        id_user = isUserFiltrado.id
      }else{
        id_user = sessionStorage.getItem('id_user')
      }

      AreaDataService.getAreasPorAdministrador(id_user,this.key).then(async (response) => {
        this.areasAdministrador = await Crypto.desencriptar(response.data, this.key);
        this.master = this.esUsuarioMaster()
      });
    },

    newUser() {
      this.submitted = false;
      this.usuario = {};
    },

    inputSelect() {
      this.$emit(
        "input",
        this.roles.find((item) => item.id === this.selected)
      );
    },

    inputSelectAdmin() {
      this.$emit(
        "input",
        this.usuariosAdmin.find((item) => item.id === this.selectedAdmin)
      );
    },

    async usuariosByRolAndArea(idArea){
      try {
        const res = await UsersDataService.getUsuariosByRolAndArea(idArea, this.key)
        this.usuariosAdmin = res.data
        this.usuariosAdmin = this.usuariosAdmin.filter(usuario => usuario.habilitado !== false)
      } catch (error) {
        generalSweetAlert(this.$t('Gral.msgErrorDesconocido'), 'error')
      }
    },

    registrarAccion() {
      var data = {
        usuario: this.usuarioLogueado,
        accion: this.accion + sessionStorage.infoDevice,
        fechaCreacion: new Date(),
        tipo: "accion",
      };
      AccionesDataService.create(data, this.key);
    },

    esUsuarioMaster() {
      
        const isUserFiltradoString = sessionStorage.getItem("usuarioFiltro");
      
        if (isUserFiltradoString != 'null' && isUserFiltradoString != '' && isUserFiltradoString != null) {
            //Es un usuario master que accedio a vista de Administrador
            try {
                const isUserFiltrado = JSON.parse(isUserFiltradoString);

                if (isUserFiltrado.rol.id === "6081c4becaae9b0d5e87e61b") {
                    return false;
                }
            } catch (e) {
                console.error("Error al parsear usuarioFiltro:", e);
                return true;
            }
        } else {
          if (sessionStorage.idRol === "6081c4becaae9b0d5e87e61b") {
            // Es usuario administrador
            return false;
          }else if (sessionStorage.idRol == process.env.VUE_APP_ID_MASTER) {
            // 4. Comprobación final del rol Master (basado en el usuario logueado)
            return true;
          }
        }

        // Si ninguna condición se cumple, por defecto devolvemos false (si no es Master y si el filtro no era el especificado)
        return true;
    },


  },//END Methods
};
</script>